import { render } from "./DocItem.vue?vue&type=template&id=b3578620&scoped=true"
import script from "./DocItem.vue?vue&type=script&lang=ts"
export * from "./DocItem.vue?vue&type=script&lang=ts"

import "./DocItem.vue?vue&type=style&index=0&id=b3578620&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b3578620"

export default script